export class Accessibility{

    private static clickableElements: HTMLCollectionOf<Element>;
    private static focusElementsForOuterDisplay: HTMLCollectionOf<Element>;

    public static init(){
        document.addEventListener('DOMContentLoaded', this.onDocumentLoaded, false)
    }

    private static onDocumentLoaded() {
        Accessibility.clickableElements = document.getElementsByClassName('clickable');
        if (Accessibility.clickableElements) {
            for ( let item of Accessibility.clickableElements ) {
                item.addEventListener('keypress', Accessibility.triggerClickOnEnter);
            }
        }

        Accessibility.focusElementsForOuterDisplay = document.getElementsByClassName('displayOuterOnFocus');
        if (Accessibility.focusElementsForOuterDisplay) {
            for ( let item of Accessibility.focusElementsForOuterDisplay ) {
                item.addEventListener('focusin', Accessibility.displayOuterElement);
                item.addEventListener('focusout', Accessibility.removeOuterElement);
            }
        }
    }

    private static triggerClickOnEnter(event) {
        if (event.key === "Enter") {
            event.preventDefault();
            event.target.click();
        }
    }

    private static displayOuterElement(event) {
        event.target.closest('.displayOnInnerFocus').setAttribute("style", "display: block; max-height: 5000px; opacity: 1;");
    }

    private static removeOuterElement(event) {
        event.target.closest('.displayOnInnerFocus').setAttribute("style", "");
    }
}
